import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  Manager,
  Target,
  Popper,
} from 'react-popper';
import cx from 'classnames';

import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';

import LoginForm from '../../forms/LoginForm/LoginForm';

import {
  login,
  logout,
} from '@actions/auth';
import {
  closeMenu,
  toggleMenu,
} from '@actions/loginMenu';

import { isMenuOpen } from '@selectors/loginMenu';
import { isUserLoggedIn } from '@selectors/auth';

import './LoginMenu.scss';

const LoginMenu = ({
  buttonClassName,
  closeMenu,
  isMenuOpen,
  isUserLoggedIn,
  login,
  logout,
  toggleMenu,
}) => (
  <div className="login-menu">
    {!isUserLoggedIn && (
      <Manager>
        <Target>
          <Button
            onClick={() => toggleMenu(isMenuOpen)}
            data-trigger="true"
            className={buttonClassName}
          >
            Log In
          </Button>
        </Target>
        <Popper
          placement="bottom-end"
          eventsEnabled={isMenuOpen}
          className={cx('login-menu__popper', { 'login-menu__popper--hidden': !isMenuOpen })}
        >
          <ClickAwayListener onClickAway={isMenuOpen ? closeMenu : () => {}}>
            <Grow in={isMenuOpen}>
              <Paper>
                <LoginForm onSubmit={login} />
              </Paper>
            </Grow>
          </ClickAwayListener>
        </Popper>
      </Manager>
    )}
    {isUserLoggedIn && (
      <Button
        onClick={logout}
        className={buttonClassName}
      >
        Log Out
      </Button>
    )}
  </div>
);

LoginMenu.propTypes = {
  buttonClassName: PropTypes.string,
  closeMenu: PropTypes.func.isRequired,
  isMenuOpen: PropTypes.bool.isRequired,
  isUserLoggedIn: PropTypes.bool.isRequired,
  login: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  toggleMenu: PropTypes.func.isRequired,
};

LoginMenu.defaultProps = {
  buttonClassName: 'login-menu__button',
};

const mapStateToProps = state => ({
  isMenuOpen: isMenuOpen(state),
  isUserLoggedIn: isUserLoggedIn(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  closeMenu,
  login,
  logout,
  toggleMenu,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LoginMenu);



// WEBPACK FOOTER //
// ./src/routes/containers/LoginMenu/LoginMenu.js